import { defineMessages, useIntl } from 'react-intl';

import SocialShare from '../SocialShare';

const messages = defineMessages({
  socialShareTitle: {
    id: 'Social media share links',
    defaultMessage: 'Social media share links',
  },
});

const SocialShareFooter = (props) => {
  const intl = useIntl();

  return (
    <div
      className="ui container pb-2 mt-4"
      role="region"
      aria-labelledby="social-share-footer-heading"
    >
      <h2 id="social-share-footer-heading" className="sr-only">
        {intl.formatMessage(messages.socialShareTitle)}
      </h2>
      <span className="br-divider mb-2" />
      <div className="d-flex justify-content-center justify-content-sm-end">
        <SocialShare url={props.content?.['@id']} />
      </div>
      <span className="br-divider mb-2" />
    </div>
  );
};

export default SocialShareFooter;
